import styles from "./styles.module.scss";
import Flag from "@assets/img/flag.svg";
import CopyIcon from "@assets/icons/CopyIcon";
import { FC } from "react";

interface AsinBtnProps {
  asin: string;
}

export const AsinBtn: FC<AsinBtnProps> = ({ asin }) => {
  const copyToClipboard = () => navigator.clipboard.writeText(asin);

  return (
    <button
      type="button"
      className={styles.productCode}
      onClick={copyToClipboard}
      aria-label={`Copy ASIN ${asin} to clipboard`}
    >
      <img
        src={Flag}
        alt="USA Flag"
        className={styles.flag}
        width={13}
        height={11}
      />
      <span className={styles.code}>{asin}</span>
      <CopyIcon fill="#7C7C78" />
    </button>
  );
};

export default AsinBtn;
